import qs from 'qs';

function _getKeyValue(pair) {
  const keyValuePair = pair.split('=');
  const key = decodeURIComponent(keyValuePair[0]);
  const value = (keyValuePair.length > 1) ? decodeURIComponent(keyValuePair[1]) : undefined;

  return {
    key,
    value,
  };
}

function _createInput(name, value) {
  return $('<input>').attr({
    type: 'hidden',
    name,
    value,
  });
}

function _createPostForm(url) {
  return $('<form method="post"></form>').attr({ action: url });
}

function _submit(form) {
  form.appendTo('body').submit();
}

const redirect = {
  postFromQueryString(url, queryString) {
    const form = _createPostForm(url);

    const pairs = qs.parse(queryString);
    if (pairs.length === 0) {
      _submit(form);
    }

    for (let index = 0; index < pairs.length; index += 1) {
      const keyValue = _getKeyValue(pairs[index]);
      form.append(_createInput(keyValue.key, keyValue.value));
    }

    _submit(form);
  },

  post(url, parameters) {
    const form = _createPostForm(url);

    Object.keys(parameters).forEach(key => {
      form.append(_createInput(key, parameters[key]));
    });

    _submit(form);
  },

  get(url) {
    if (document.location.href === url) {
      document.location.reload();
    } else {
      document.location.href = url;
    }
  },
};

export default redirect;



// WEBPACK FOOTER //
// ./common/redirect.lib.js